/*
 * Copyright 2023 Adobe
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 */
import { useExtensions, TypedGuestConnection } from '@adobe/uix-host-react'
import { GuestApis } from '@adobe/uix-core'
import { UixFrame, updatePageTitle } from './utils'
import { PageAppProps } from './props/PageAppProps'

const retrieveAndUpdatePageTitle = (
  extension: TypedGuestConnection<GuestApis>
) => {
  extension.apis.page
    ?.getTitle()
    .then((pageTitle: string) => updatePageTitle(pageTitle))
    .catch(() => updatePageTitle(''))
}

export const MenuPage = ({ extensionId }: PageAppProps) => {
  const { extensions } = useExtensions(() => ({
    updateOn: 'all',
    requires: {
      menu: ['getItems']
    },
    provides: {
      integration: {
        getCommerceHost() {
          return window.location.host
        }
      }
    }
  }))

  const extension = extensions.find((item) => item.id === extensionId)
  if (!extension) {
    return <></>
  }

  retrieveAndUpdatePageTitle(extension)
  return (
    <UixFrame
      url={extension.url.origin}
      extensionId={extension.id}
      redirectUrl={''}
    />
  )
}
